import { GradesDTO } from "../dto/GradesDTO";

export const getGradeNameByLanguage = (grade: GradesDTO, language: string) => {
    switch (language.toLowerCase()) {
      case 'english':
        return grade.engName;
      case 'french':
        return grade.frName;
      case 'arabic':
        return grade.arName;
      default:
        return grade.engName;
    }
  };